import React from 'react'
import {NullAsDefault} from 'views/Shared'
import {renderIf} from "../../../Shared";
import getTitle from "../../../../helpers/getTitle";
import {GoDotFill} from "react-icons/go";
import {Avatar} from "antd";
import {RiUser2Fill} from "react-icons/ri";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import {ItemInformation} from "../../../../components/common/ItemInformation";
import {DatePlaceItem} from "../../../../components/common/DatePlaceItem";


export const renderCatholicHouseholdMemberWithSacrament =
    ({translate: t, renderContextMenu = NullAsDefault, handleAction = NullAsDefault} = {}, sacrament_type) => (item, index) => {

        const {member_user, patron_saint_name, name, sacraments = [],} = item ?? {}

        const SacramentInfo = ({type}) => (
            sacraments.map((e, i) => {
                const {eff_date, church_name, officiant_name, participant_name, sacrament_type} = e ?? {}
                return (
                    renderIf(
                        type === sacrament_type,
                        <div key={i} style={{marginLeft: 10}} className="flex flex-col gap-1">
                            <DatePlaceItem
                                showIcon={true}
                                label={type === 'matrimony' ? t('date of celebration') : `${t('date')} ${t(type)}`}
                                date={formatSimplifyDate(eff_date, 'medium')}
                                place={church_name}
                                className="italic tracking-wider"
                            />
                            {renderIf(
                                officiant_name,
                                <div className="space-x-1 italic tracking-wider">
                                    <GoDotFill size={10} className="text-color-400"/>
                                    <span className="text-color-500 whitespace-no-wrap">
                                    {`${t('by_prelate')} : `}
                                </span>
                                    <span className="font-semibold text-color-100">
                                    {officiant_name}
                                </span>
                                    <span className="text-color-500 whitespace-no-wrap">
                                    {`${t("celebrate")}.`}
                                </span>
                                </div>
                            )}
                            {renderIf(
                                participant_name,
                                <ItemInformation
                                    showIcon={true}
                                    label={type === 'matrimony' ? 'marriage witnesses' : 'godparent'}
                                    value={participant_name}
                                    className="italic tracking-wider"
                                />
                            )}
                        </div>
                    )
                )
            })
        )

        return (
            <div key={index} className="p-4 flex flex-col custom-item-render relative list-item">
                <div className="flex items-center gap-x-2">
                    <Avatar
                        size={36}
                        src={member_user?.avatar}
                        icon={<RiUser2Fill size={16} className="text-color-500"/>}
                        className="flex flex-center background-200"
                    />
                    <div
                        onClick={() => {
                            handleAction('CATHOLIC_HOUSEHOLD_MEMBER_VIEW', item)
                        }}
                        className="flex-1 space-x-1 text-color-000 hover:text-primary cursor-pointer mr-6">
                    <span className="font-medium text-sm text-color-100">
                        {patron_saint_name}
                    </span>
                        <span className="font-bold text-lg tracking-wide">
                        {name ? name : getTitle(member_user)}
                    </span>
                    </div>
                </div>
                <div className="my-2 border-b border-color-50"/>
                <SacramentInfo type={sacrament_type}/>
                <div className="absolute right-8 top-8 contextIcon">
                    {renderContextMenu(item)}
                </div>
            </div>
        )
    }



